import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { PoLookupColumn, PoLookupComponent, PoLookupFilter, PoLookupLiterals, PoNotificationService } from '@po-ui/ng-components';
import { ContextApplication } from 'src/app/Context/contextapplication/contextapplication';
import { InputLookupService } from 'src/app/Input/inputcharts/inputservices/inputlookup.service';
import { PageBase } from 'src/app/shared/library/page.base';
import { GenericResultsApi } from 'src/service/apis-cockpit';
import { LookupService } from 'src/service/lookup-filter-service';
import { TaskItem } from '../taskcommon/taskcommon.class';
import { TaskInputComponent } from '../taskinput/taskinput.component';
import { TaskInputService } from '../taskinput/taskinput.service';

@Component({
    selector: 'cp-task-board',
    templateUrl: './taskboard.component.html',
    styleUrls: ['./taskboard.component.css'],
    standalone: false
})
export class TaskboardComponent extends PageBase implements OnInit {

  @ViewChild('lookupTarefas', { static: true }) lookupTarefas: PoLookupComponent; // Acesso do lookup para outros componentes
  @ViewChild('taskinput', { static: true }) taskInput: TaskInputComponent;

  columns: Array<PoLookupColumn>;
  columnsName: Array<string>;
  customLiterals: PoLookupLiterals;
  event: string;
  fieldLabel: string;
  fieldValue: string;
  filterService: PoLookupFilter | string;
  help: string;
  label: string;
  placeholder: string;
  properties: Array<string>;
  taskDescription = '';
  taskCode = '';
  contratoValorMedidoCalculado: any;
  taskContractsValues: any[] = [];
  taskitem: TaskItem;


  constructor(private taskInputService: TaskInputService,
    public poNotification: PoNotificationService,
    public inputLookupService: InputLookupService,
    public contextApplication: ContextApplication,
    public sampleFilterService: LookupService,
    public objInjector: Injector) {
    super(objInjector);
  }

  public readonly columnsDefinition = {
    label: { property: 'taskCode', label: '', width: '20%', fieldLabel: true } as PoLookupColumn,
    value: { property: 'name', label: '', fieldLabel: true } as PoLookupColumn,
    desc: { property: 'description', label: '' } as PoLookupColumn,
  };

  ngOnInit(): void {
    super.ngOnInit();
    this.restore();
    this.literalsBoard();
  }

  literalsBoard() {
    this.columnsDefinition.label.label = this.literalsCp?.strCodTarefa;
    this.columnsDefinition.value.label = this.literalsCp?.strNome;
    this.columnsDefinition.desc.label = this.literalsCp?.strDescricao;
  }

  fieldFormat(obj: any) {
    if (!obj || obj === undefined) {
      return '';
    }
    else {
      if (obj.items) {
        const tarefas = obj as GenericResultsApi;
        return this.generateFieldTaskFormat(tarefas);
      }
      else {
        return `${obj['taskCode']} - ${obj['name'] ? obj['name'] : obj['description']}`;
      }
    }
  }

  generateFieldTaskFormat(tarefas: GenericResultsApi): string {

    let taskDescription = '';
    if (tarefas.items.length > 0) {
      taskDescription = tarefas.items[0].name ? tarefas.items[0].name : tarefas.items[0].description;
    }

    return taskDescription;
  }

  changeEvent(event: any) {
    if (event) {
      this.sampleFilterService.IsSearching = false;
      if (event['$selected']) {
        this.InsertInfoTask(event);
      }
      else {
        const itens = event as GenericResultsApi;
        if (itens.items != undefined && itens.items.length > 0) {
          this.InsertInfoTask(event['items'][0]);
        }
        else {
          this.poNotification.warning(this.literalsCp.strTarefaNaoEncontrada);
        }
      }
    }
  }

  restore() {
    this.columnsName = ['label', 'value', 'desc'];
    this.customLiterals = undefined;
    this.updateColumns();
    this.fieldLabel = 'name';
    this.fieldValue = 'name';
    this.taskDescription = this.fieldLabel;
    this.event = undefined;
    this.filterService = undefined;
    this.label = 'Tarefa';
    this.help = undefined;
    this.properties = [];
  }

  updateColumns() {
    this.columns = [];
    this.columnsName.forEach(column => this.columns.push(this.columnsDefinition[column]));
  }

  private InsertInfoTask(task: any) {
    this.taskDescription = task['description'];
    this.taskCode = task['taskCode'];

    this.taskitem = new TaskItem();
    this.taskitem.companyid = task['companyId'];
    this.taskitem.projectid = task['projectId'];
    this.taskitem.taskid = task['taskId'];
    this.contextApplication.hiddenDashboardTaskInput[0] = false;
  }

  public RefreshData() {
    if (this.taskitem && this.taskitem.taskid) {
      const newTaskInfo = {
        description: this.taskDescription,
        taskCode: this.taskCode,
        companyId: this.taskitem.companyid,
        projectId: this.taskitem.projectid, taskId: this.taskitem.taskid
      };
      this.InsertInfoTask(newTaskInfo);
    }
  }

  onReceiveLiterals() { }
}
